import {ElementsWithFilter} from "../../common/elements-with-filter/elements.with.filter";
import { promotionsTemplateHtml } from '../../common/templates/promotions-template.html';

const name = 'promotions';
export class PromotionsPage {
  constructor(
    private switchers: HTMLElement[],
    private loader: HTMLElement | null
  ) {}
  public initialize(): void {
    const elementsWithFilter: HTMLElement | null = document.querySelector(`[data-elements-with-show-more]`);
    if (elementsWithFilter && elementsWithFilter.dataset.elementsWithShowMore === name) {
      new ElementsWithFilter(
        elementsWithFilter,
        this.loader,
        this.switchers,
        6,
        promotionsTemplateHtml,
        name,
        name
      );
    }
  }
}
